export default __webpack_public_path__ + "static/media/ic-right-arrow.7583fc18.svg";